export default __webpack_public_path__ + "2284a6b44671cdead92714936eb097eb.wasm";